module.exports = "/img/word.29da51a8.png";